import Instance from "../../../../Axios";

// New Actions for the app

const GetPercOrcaAdjudicadosPeloTotal =
  (parceirosId, dataInicio, dataFim) => async (dispatch) => {
    await Instance()
      .get(`/energias/dashboard/percOrcaAjudicadosPeloTotal`, {
        params: { parceirosId, dataInicio, dataFim },
      })
      .then(({ data }) => {
        //   console.log(data);
        dispatch({
          type: "GET_PERC_ORCAMENTO_ADJUDICADO",
          payload: data.yData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default GetPercOrcaAdjudicadosPeloTotal;
